import ko from "./locales/ko.json";
import en from "./locales/en.json";

export type Locale = "ko" | "en";

export const locales: Locale[] = ["ko", "en"];
export const defaultLocale: Locale = "ko";

const messages: Record<Locale, typeof ko> = { ko, en };

export type Messages = typeof ko;

export function getMessages(locale: Locale): Messages {
  return messages[locale] ?? messages[defaultLocale];
}

/** Dot-path lookup: t("common.loading") → "불러오는 중..." */
export function translate(locale: Locale, key: string): string {
  const parts = key.split(".");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let obj: any = messages[locale] ?? messages[defaultLocale];
  for (const p of parts) {
    obj = obj?.[p];
    if (obj === undefined) break;
  }
  if (typeof obj === "string") return obj;
  // Fallback to default locale
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let fallback: any = messages[defaultLocale];
  for (const p of parts) {
    fallback = fallback?.[p];
    if (fallback === undefined) break;
  }
  return typeof fallback === "string" ? fallback : key;
}
